import type React from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

type Props = {
	isUploading: boolean;
	onTryAgain: () => void;
	onSubmit: () => void;
};

/**
 * What the supporter can do with a take before it is attached: submit it, or go again.
 *
 * Copy link and Delete were dropped here on product's call (CHANGE-97688, 2026-09-03). Both only make
 * sense once the video exists - it has no address to copy and nothing to delete until it is submitted -
 * and the confirmation screen offers both a moment later. Delete in particular was judged likely to
 * depress submissions by sitting next to the submit button.
 *
 * "Try again" therefore carries the whole retry role, and takes production's label and position: below
 * the primary, not beside it.
 */
export const ReviewActions: React.FC<Props> = ({ isUploading, onTryAgain, onSubmit }) => (
	<div className="flex flex-col items-center gap-1">
		<Button
			variant="primary"
			size="large"
			className="w-full"
			onClick={onSubmit}
			loading={isUploading}
			data-testid="upload-video"
			data-qa="upload-video"
		>
			<Translate value="corgi.petition_actions.video_first_consolidated_ask.submit" />
		</Button>

		<Button
			variant="tertiary"
			size="small"
			onClick={onTryAgain}
			disabled={isUploading}
			data-testid="record-again"
			data-qa="record-again"
		>
			<Translate value="corgi.petition_actions.supporter_voice_video.submit.retry_button.label" />
		</Button>
	</div>
);
